import React from 'react';
import { Page } from '../Page';
import { SupplementCallout } from '../SupplementCallout';
export function PageChronicSideEffects() {
  return <Page pageNumber={35} variant="light" data-id="element-1081">
      <div className="flex flex-col h-full" data-id="element-1082">
        <div className="mb-8 pt-4" data-id="element-1083">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1084">
            Side Effects
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1085">
            Chronic <span className="text-tealslate" data-id="element-1086">Side Effects</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1087" />
        </div>

        <div className="mb-8" data-id="element-1088">
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-2xl" data-id="element-1089">
            While nausea and diarrhea usually fade as your body adapts to the
            medication, other side effects can persist or develop over time.
            These require ongoing management.
          </p>
        </div>

        {/* Mid-page Image Break */}
        <div className="h-[180px] -mx-12 mb-10 overflow-hidden relative" style={{
        width: 'calc(100% + 96px)'
      }} data-id="element-1090">
          <img src="https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=1000&q=80" alt="Wellness" className="w-full h-full object-cover" data-id="element-1091" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-1092">
          <div data-id="element-1093">
            <h2 className="text-xl font-serif text-[#1F1F1F] mb-3" data-id="element-1094">
              Hair Loss
            </h2>
            <p className="text-xs text-[#7A7A70] leading-[1.8] mb-4" data-id="element-1095">
              One of the most distressing side effects. Usually caused by rapid
              weight loss and inadequate protein/nutrient intake, not the
              medication itself.
            </p>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-1096">
              <p className="text-[11px] text-[#3B3B3B] leading-[1.6]" data-id="element-1097">
                <strong className="text-tealslate" data-id="element-1098">Prevention:</strong> Adequate
                protein is non-negotiable. Supplementing with biotin, iron,
                zinc, and collagen can also support follicle health.
              </p>
            </div>
          </div>

          <div data-id="element-1099">
            <h2 className="text-xl font-serif text-[#1F1F1F] mb-3" data-id="element-1100">
              Muscle Loss
            </h2>
            <p className="text-xs text-[#7A7A70] leading-[1.8] mb-4" data-id="element-1101">
              Without resistance training, up to 40% of weight lost can come
              from muscle. This lowers your metabolism and makes weight regain
              more likely.
            </p>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-1102">
              <p className="text-[11px] text-[#3B3B3B] leading-[1.6]" data-id="element-1103">
                <strong className="text-tealslate" data-id="element-1104">Prevention:</strong> Adequate
                protein + weight lifting. This is why weight lifting is one of
                the 5 essentials.
              </p>
            </div>
          </div>
        </div>

        <div className="flex-1 flex items-end gap-6" data-id="element-1105">
          <div className="flex-1" data-id="element-1106">
            <SupplementCallout title="Hair and Recovery Support" description="Biotin, collagen peptides, and a quality multivitamin support hair health and recovery during rapid weight loss." data-id="element-1107" />
          </div>
          <div className="flex-1 bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex items-center justify-between" data-id="element-1108">
            <div data-id="element-1109">
              <h3 className="font-serif text-sm text-[#1F1F1F] mb-1" data-id="element-1110">
                Need a Program?
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.5] max-w-[180px]" data-id="element-1111">
                A structured resistance training program is the single most
                effective tool.
              </p>
            </div>
            <div className="w-10 h-10 border border-[#D8D8D0] bg-white flex items-center justify-center shrink-0" data-id="element-1112">
              <span className="text-[8px] font-bold text-[#7A7A70]" data-id="element-1113">QR</span>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}